import Pdpa from './pdpa';

export default Pdpa;
